import { useState, useCallback, useMemo } from 'react';
import { CarveOutView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing carve-out search and filtering
 */
export function useCarveOutSearch(carveOuts: CarveOutView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCarveOuts = useMemo(() => {
    if (!searchTerm.trim()) return carveOuts;

    const searchLower = searchTerm.toLowerCase().trim();
    return carveOuts.filter(
      (carveOut) =>
        carveOut.code?.toLowerCase().includes(searchLower) ||
        carveOut.description?.toLowerCase().includes(searchLower) ||
        carveOut.rate?.toString().includes(searchLower)
    );
  }, [carveOuts, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredCarveOuts,
    handleSearchChange,
    handleClearSearch,
  };
}
